import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useMutationReorderRankForStoredFilterBulkAssignToUser } from 'api/mutations/reorderRankForStoredFilterBulkAssignToUser.mutation';
import {
    QueryResponse,
    useQueryGetStoredFilterBulkAssignToUser,
} from 'api/queries/getStoredFilterBulkAssignToUser.query';

import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { DndTable } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/DndTable/dndTable';
import {
    columns,
    reorderRows,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/EditBulkActionRulesPage/EditBulkActionRules/editBulkActionRules.utils';

export const EditBulkActionRules = () => {
    const { contract } = useProjectTreeStore();
    const { handleSnackBar } = useCustomSnackBar();

    const { data, refetch } = useQueryGetStoredFilterBulkAssignToUser({ contractId: contract?.id });

    const { mutate } = useMutationReorderRankForStoredFilterBulkAssignToUser();

    const handleRankReorder = (arr: QueryResponse['userAssignRule']) => {
        if (!contract) return null;

        const payload = reorderRows<QueryResponse['userAssignRule'][0]>(arr);

        mutate(
            {
                idList: payload,
                contractId: contract.id,
            },
            {
                onSuccess: () => {
                    handleSnackBar('Successfully Reordered!', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    refetch();
                },
            },
        );
    };

    return (
        <WidgetWithTitle title={'Bulk Assign Users Rules'} tooltip={data?.info}>
            {data && (
                <DndTable<QueryResponse['userAssignRule'][0]>
                    columns={columns}
                    data={data?.userAssignRule}
                    handleRankReorder={handleRankReorder}
                />
            )}
        </WidgetWithTitle>
    );
};
